import { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import { Button, Divider, Drawer, Grid, TextField, Typography, useTheme } from "@mui/material";
import { tokens } from "../../theme";

import env from "react-dotenv";
import Stack from '@mui/material/Stack';
import {
  randomId
} from '@mui/x-data-grid-generator';
import moment from "moment";
import Slider from '@mui/material/Slider';

import Modal from '@mui/material/Modal';
import { CloseRounded } from "@mui/icons-material";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

function Item(props) {
  const { sx, ...other } = props;
  return (
    <Box className="outer"
      sx={{
        // bgcolor: (theme) => (theme.palette.mode === 'dark' ? '#101010' : '#f2f0f0'),
        // color: (theme) => (theme.palette.mode === 'dark' ? 'grey.300' : 'grey.800'),
        // border: '3px solid',
        //  borderColor: (theme) =>
        //   theme.palette.mode === 'dark' ? 'grey.800' : 'grey.300',
        // p: 1,
        //  borderRadius: 2,
        fontSize: '0.875rem',
        fontWeight: '500',
        ...sx,
      }}
      {...other}
    />
  );
}
Item.propTypes = {
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool]),
    ),
    PropTypes.func,
    PropTypes.object,
  ]),
};


const Add = ({open , onClose, onSuccess}) => {
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [selected, setSelected] = useState({});
  const [date, setDate] = useState(moment(new Date()).format("yyyy-MM-dd").toString());
  const [monthyear, setMonthYear] = useState(null);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [isSaving, setIsSaving] = useState(false);
  const submitLockRef = useRef(false);
  const [mainProductsSet, setMainProductsSet] = useState(new Set());

  const [record, setRecord] = useState({
    YearMonth: "",
  });

  const location = useLocation();
  useEffect( () => {
    if(location.key === undefined || location.key === null || location.key === 'default'){
      navigate("/");   
    }
  }, [ location ] );


  const [data, setData] = useState({
  
    YearMonth: "",
    ABPB: "0",
    BJRL: "",
    BJTL: "",
    PBS: "",
    RPPS: "",
    RPLBS: "",
    LBS: "",
    TCEJ : "",
    RS: "",
    MEP:"",
  });

  // Fetch allowed items from main_product and build normalized set
  useEffect(() => {
    const fetchMainProducts = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_PJCBACKEND_URL}/api/main-product`, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' },
        });
        const pdata = await res.json();
        const names = new Set();
        const norm = (s) => String(s || '').trim().replace(/\s+/g, ' ').toUpperCase();
        const pushName = (v) => {
          const n = norm(v);
          if (n) names.add(n);
        };
        const keys = ['product','Product','product_name','ProductName','item','Item','item_name','ItemName','name','Name'];
        if (Array.isArray(pdata)) {
          pdata.forEach((row) => {
            if (typeof row === 'string') {
              pushName(row);
              return;
            }
            if (!row || typeof row !== 'object') return;
            keys.forEach((k) => {
              const val = row[k];
              if (typeof val === 'string' && val.trim()) pushName(val);
            });
          });
        }
        setMainProductsSet(names);
      } catch (e) {
        setMainProductsSet(new Set());
      }
    };
    fetchMainProducts();
  }, []);

  // Build dynamic product fields from main_product; fallback to legacy static list if empty
  const staticFields = ['ABPB','BJRL','BJTL','PBS','RPPS','RPLBS','LBS','TCEJ','RS','MEP'];
  const productFields = Array.from(mainProductsSet);
  productFields.sort((a, b) => a.localeCompare(b));
  const effectiveFields = productFields.length > 0 ? productFields : staticFields;
  const fieldsCol1 = effectiveFields.slice(0, Math.ceil(effectiveFields.length / 2));
  const fieldsCol2 = effectiveFields.slice(Math.ceil(effectiveFields.length / 2));

 

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
   
  }


  const handleSubmitOnDB = async (e) => {
    e.preventDefault();
    if (isSaving || submitLockRef.current) {
      return;
    }

    // Clear previous errors
        setErrors({});
    
        // Validate the form
        const newErrors = validateForm(data);
        
        if (monthyear !== null) {
            // Update the record with the selected YearMonth
            const formattedYearMonth = moment(new Date(monthyear)).format("MMM-yyyy").toString();
            record["YearMonth"] = formattedYearMonth;
            // Check if the YearMonth already exists in the database
            const exists = await getYearMonthFromDB();
            if (exists > 0) {
                newErrors.YearMonth = "YearMonth already exists";        
            } else {
                // If it doesn't exist, set the YearMonth in the data object
                data['YearMonth'] = formattedYearMonth;
            }
        } else {
            newErrors.YearMonth = "YearMonth is required"; // Add this line to handle null case
        }
        setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      // Form submission logic here
      Object.keys(data).map((item) => (
        (() => {
          switch(item) {
            case "id": data['id'] = "mis"+Math.floor(Math.random() * 100000)
           
            default: console.log("1");
          }
        })()
      ))
      // if(monthyear !== null){
      //   data['YearMonth'] = moment(new Date(monthyear)).format("MMM-yyyy").toString()
      // }
      try { 
        submitLockRef.current = true;
        setIsSaving(true);
      
        const res = await fetch(
           `${process.env.REACT_APP_MISBACKEND_URL}/warranty`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
          }
        );
        
        onClose();
        onSuccess();
      } catch (error) {
        console.log(error);
      } finally {
        submitLockRef.current = false;
        setIsSaving(false);
      }
    } else {
        console.log(`Form submission failed
        due to validation errors.`);
    }   
  };

  
  const validateForm = (data) => {
      const errors = {};
    //   if (data.WorkType.trim() == 'Machine Maintenance' && !data.Machine.trim()) {
    //       errors.Machine = 'Machine is required if worktype is machine maintenance';
    //       console.log(errors.Machine);
    //   }
      return errors;
  };

  const getYearMonthFromDB = async () => {
    try { 
       const resSlip = await fetch(
         `${process.env.REACT_APP_MISBACKEND_URL}/warrantyYearMonth`,
         {
           method: "POST",
           headers: {
             "Content-Type": "application/json",
           },
           body: JSON.stringify(record),
         }
       );
       const response = await resSlip.json();
      
       return response.length;
     } catch (error) {
       console.log(error);
     }
   } 

  const style = {
    position: 'absolute',
    top: '55%',
    left: '60%',
    transform: 'translate(-50%, -50%)',
    width: 1000,
    border: '2px solid #555',
    boxShadow: 24,
    p: 4,
  };

  
  function Bar() {
    return (
      <Box
        sx={{
          height: 3,
          backgroundColor: (theme) =>
            theme.palette.mode === 'light'
              ? 'rgba(0, 0, 0, 0)'
              : 'rgb(0, 0, 0, 0)',
        }}
      />
    );
  } 

  const handleClose = () => {
     // Reset the monthyear and data state
    setMonthYear(null);
    setData({
      YearMonth: "",
      ABPB: "0",
      BJRL: "",
      BJTL: "",
      PBS: "",
      RPPS: "",
      RPLBS: "",
      LBS: "",
      TCEJ: "",
      RS: "",
      MEP: "",
    });
    setErrors({});
    navigate("../efficiencyHome/3");    
  }
  const modalStyle1 = {
    maxWidth: 600,marginLeft:"330px", marginTop:"50px",height:"300px"
      // overflow:'scroll',
    };

  function  handleChangeRaw(value) {
    setMonthYear(value);
     }

  return (open) ? (
      <Drawer
        anchor="right"
        open={open}
        onClose={onClose}
        PaperProps={{
          sx: {
            width: 730,
            padding: 2,
          }
        }}
      >
      <div style={{ width: "100%"}}  >
    
      <form style={{ marginLeft:"5px",marginRight:"5px",marginTop:"5px",
          marginBottom:"5px", p: 2,}} onSubmit={handleSubmitOnDB}>
            <Typography variant="h4" align="center" color="#4863A0" gutterBottom>
            Add Warranty Record
            </Typography>
            <Divider style={{ marginBottom: '20px' }} />   
            <label hidden htmlFor="id" className="form-label">
                id
            </label>
            <input type="hidden" name="id"/>      
            <Box className="outerbox" sx={{ display: 'grid', gridTemplateColumns: 'repeat(1, 2fr)', gap: 2 ,m:1}}>
                <Item>
                  <FormControl size="medium" fullWidth>
                  <label>YearMonth</label>
                  <DatePicker
                    onChangeRaw={(event) =>
                    handleChangeRaw(event.target.value)}
                    disabledKeyboardNavigation
                    showMonthYearPicker
                    required
                    name="YearMonth"
                    selected={monthyear}          
                    className="customInput"
                    popperProps={{
                      positionFixed: true // use this to make the popper position: fixed
                    }}                    
                      autoComplete="off"        
                      // onChange={(monthyear) => setMonthYear(new Date(monthyear))}
                       onChange={(monthyear) => {
                        setMonthYear(new Date(monthyear));
                        // Clear the YearMonth error when the date is changed
                        setErrors((prevErrors) => ({
                          ...prevErrors,
                          YearMonth: '' // or you can use '' to clear the message
                        }));
                      }}
                      dateFormat="MMM-yyyy"
                    />
                     {errors.YearMonth &&
                      <span style={{ color: 'red'}} className="error-message">
                          {errors.YearMonth}
                      </span>
                    }
                  <Bar/>

                  </FormControl>
                </Item>
            </Box>
            <Box className="outerbox" sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 2fr)', gap: 2 ,m:1}}>
              <Item>
                <FormControl size="medium" fullWidth>
                  {fieldsCol1.map((field) => (
                    <Box key={field}>
                      <label style={{ display: 'block' }}>{field}</label>
                      <TextField
                        size="small"
                        fullWidth
                        name={field}
                        type="number"
                        value={data[field] ?? ''}
                        onChange={handleChange}
                        variant="outlined"
                      />
                      <Bar/>
                    </Box>
                  ))}
                </FormControl>
              </Item>
              <Item>
                <FormControl size="medium" fullWidth>
                  {fieldsCol2.map((field) => (
                    <Box key={field}>
                      <label style={{ display: 'block' }}>{field}</label>
                      <TextField
                        size="small"
                        fullWidth
                        name={field}
                        type="number"
                        value={data[field] ?? ''}
                        onChange={handleChange}
                        variant="outlined"
                      />
                      <Bar/>
                    </Box>
                  ))}
                </FormControl>
              </Item>
            </Box>
            <Divider style={{ marginTop: '20px' }} />    
            <Grid item xs={12} sx={{ marginTop:"20px", display: 'flex', justifyContent: 'center' }}>
              <Button size="large" onClick={() => [onClose(), handleClose()]} color="secondary" sx={{ marginRight: 2,':hover': {
                      bgcolor: '#4863C0', // theme.palette.primary.main
                      color: 'white',
                    }, }}>
                Cancel
              </Button>
              <Button size="large" disabled={isSaving} onClick={handleSubmitOnDB}  sx={{backgroundColor:'#4863A0',':hover': {
                      bgcolor: '#4863C0', // theme.palette.primary.main
                      color: 'white',
                    },}} variant="contained">
                Save
              </Button>            
            </Grid>
      </form>
      </div>    
    </Drawer>
    
  ): ""
};

export default Add;